import { Action } from 'redux';

import { EditFlow } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';

export interface EditFlowReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function editFlow(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): EditFlowReduxAction {
  return {
    type: EditFlow,
    flow
  };
}
